import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Client } from '../types/Client';
import { withRouter } from 'react-router-dom';
import DialogHeader from "../common/DialogHeader";
import DialogFooter from "../common/DialogFooter";
import getCountryList from '../assets/countryListUtility';
import {
  addClient,
  addClientToastClose,
  addClientCorrection,
  isLoadingTrue,
  isLoadingFalse,
  getMasterClients
} from '../actions/userActions';

import {
  withStyles,
  WithStyles,
  Card,
  CardContent,
  CardActions,
  Checkbox,
  Typography,
  Modal,
  CardHeader,
  IconButton,
  Button,
  Grid,
  FormControl,
  FormControlLabel,
  FormGroup,
  Radio,
  Icon,
} from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import CloseIcon from '@material-ui/icons/Close';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CustomInfoIcon from '../../common/CustomInfoIcon';
import { userStyles } from '../styles';
import { MyPATTextField, MyPATDialog, MyPATSelect } from '../../common';
import { MyPATSnackbar } from '../../common';
import { GOAL_ACTION_TYPE_CONST } from '../../goal-management/container/GoalManagementContainer';
import classNames from 'classnames';
import clientServices from '../services/userServices';

interface AddClientDialogProps extends WithStyles<typeof userStyles> {
  isDialogOpen: boolean;
  dialogCloseHandler: () => void;
  dialogData: any;
  actionType: string;
  getGoalList: () => void;
  id: string;
  history: any;
  eventsName: any;
  addClient: any;
  formErrors: any;
  clientAddedSuccessfully: boolean;
  addClientToastClose: any;
  addClientCorrection: any;
  isLoadingFalse: any;
  isLoadingTrue: any;
  isIniitated: any;
  getMasterClients: any;
  masterClientsData: any;
}

interface ModuleAccess {
  goalManagement: boolean;
  userManagement: boolean;
  courseManagement: boolean;
  EDPReports: boolean;
  contentRequest: boolean;
}

interface AddClientDialogState {
  open: boolean;
  setOpen: boolean;
  formData: any;
  formErrors: any;
  isFormValid: any;
  showToaster: boolean;
  showDialog: boolean;
  masterClientsDataUpdated: MasterClientData[];
}

interface MasterClientData {
  _id: string, 
  name: string
}

class AddClientDialog extends Component<
  AddClientDialogProps,
  AddClientDialogState
> {
  constructor(props: AddClientDialogProps) {
    super(props);
    this.state = {
      open: false,
      setOpen: false,
      formData: {
        client: {
          name: '',
          address: '',
          moduleAccess: [
            {
              type: 'module',
              name: 'goal',
              isAllowed: 'true',
            },
            {
              type: 'module',
              name: 'course',
              isAllowed: 'true',
            },
            {
              type: 'module',
              name: 'content',
              isAllowed: 'true',
            },
            {
              type: 'module',
              name: 'user',
              isAllowed: 'true',
            },
            {
              type: 'module',
              name: 'edp',
              isAllowed: 'true',
            },
          ],
          isBranchClient: false,
          masterClient: {
            id: '',
            name: ''
          }
        },
        user: {
          fullName: '',
          email: '',
          mobile: {
            countryCode: '+91',
            number: '',
          },
          empCode: '',
        },
      },
      formErrors: {
        name: 'valid',
        address: 'valid',
        fullName: 'valid',
        email: 'valid',
        number: 'valid',
        empCode: 'valid',
      },
      isFormValid: false,
      showToaster: true,
      showDialog: false,
      masterClientsDataUpdated: []
    };

    this.handleChange = this.handleChange.bind(this);
  }

  getMasterClientName = (id:string) => {
    return this.props.masterClientsData.filter((client:MasterClientData) => client._id === id)
  }

  handleChange = (event: any) => {
   if(event.preventDefault){ 
      event.preventDefault();
    }
    let { formData, formErrors } = this.state;
    let { name, value } = event.target;    
    
    this.props.addClientCorrection();

    if (this.anyFormErrors()) {
      let error = this.validateField(name, value);
      if (error !== undefined && error !== '') {
        
        formErrors[name] = error;
      }
    }

    switch (name) {
      case 'name':
        value = value.replace(/[^\w\s]/gi, "");
        formData.client.name = value;
        break;
      case 'address':
        formData.client.address = value;
        break;
      case 'fullName':
        value = value.replace(/[^\w\s]/gi, "");
        formData.user.fullName = value;
        break;
      case 'empCode':
        formData.user.empCode = value;
        break;
      case 'email':
        formData.user.email = value;
        if(formData.client.isBranchClient && this.checkEmailValidity(value.trim())) {
          clientServices.getUsersByEmail(value).then((res: any) => {
            formData.user.mobile.countryCode = _.get(res, 'users[0].mobile.countryCode', '+91') ? _.get(res, 'users[0].mobile.countryCode', '+91') : formData.user.mobile.countryCode;
            formData.user.mobile.number = _.get(res, 'users[0].mobile.number', '') ?  _.get(res, 'users[0].mobile.number', '') : formData.user.mobile.number;
            let name = `${_.get(res, 'users[0].firstName', '')} ${_.get(res, 'users[0].lastName', '')}`;;
            name = name.replace(/[^\w\s]/gi, "");
            name = name.trim();
            formData.user.fullName = name !== "" ? name : formData.user.fullName;
          })
        }
        break;
      case 'countryCode':
        formData.user.mobile.countryCode = value;
        break;
      case 'number':
        formData.user.mobile.number = value;
        break;
      case 'checkbox':
        formData.client.isBranchClient = !formData.client.isBranchClient;
        break;
      case 'masterClient':
        formData.client.masterClient.name = this.getMasterClientName(value)[0] && this.getMasterClientName(value)[0].name;
        formData.client.masterClient.id = this.getMasterClientName(value)[0] && this.getMasterClientName(value)[0]._id;
        break;
      default:
    }
    setTimeout(() => {
      this.setState({ formData, formErrors });
    }, 1000)
    this.anyFormErrors();
    if(this.isFormEmptyCheck()){
      this.setState({
        isFormValid: false
      })
    }
    
  };

  validateField = (name: any, value: any) => {
    switch (name) {
      case 'name':
        return this.checkclientNameValidity(value)
          ? 'valid'
          : 'Please enter atleast 3 characters';
      case 'address':
        return this.checkclientAddressValidity(value)
          ? 'valid'
          : 'Please enter atleast 5 characters';
      case 'fullName':
        return this.checkUserNameValidity(value)
          ? 'valid'
          : 'Please enter atleast 3 characters';
      case 'email':
        return this.checkEmailValidity(value.trim())
          ? 'valid'
          : 'Please enter a valid email ID';
      case 'empCode':
        return this.checkEMPCodeValidity(value)
          ? 'valid'
          : 'Please enter a valid EMP Code';
      case 'number':
        return this.checkmobileValidity(value)
          ? 'valid'
          : 'Please enter a valid mobile number';
      default:
        return '';
    }
  };

  checkclientNameValidity = (clientName: string) => {
    let isclientNameValid = true;
    if (clientName === '' || clientName.length < 3) {
      isclientNameValid = false;
      
    }
    return isclientNameValid;
  };

  checkclientAddressValidity = (clientAddress: string) => {
    let isclientAddressValid = true;
    if (clientAddress === '' || clientAddress.length < 5) {
      isclientAddressValid = false;
    }
    return isclientAddressValid;
  };

  checkUserNameValidity = (name: string) => {
    let isNameValid = true;
    if (name === '' || name.length < 3) {
      isNameValid = false;
    }
    return isNameValid;
  };

  checkEmailValidity = (email: string) => {
    let isEmailValid = true;
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    isEmailValid = re.test(String(email).toLowerCase());
    if (isEmailValid) {
      return isEmailValid;
    } else {
      return false;
    }
    // else if (this.props.formErrors.email) {
    //   this.props.formErrors.email = 'This field is required.';
    //   return true;
    // }
  };

  checkEMPCodeValidity = (code:string) => {
    let isCodeValid = true;
    if (code.length !== 5) {
      isCodeValid = false;
    }
    return isCodeValid;
  }

  checkmobileValidity = (mobile: string) => {
    let ismobileValid = true;
    
    const allCountries = getCountryList();
    const country = allCountries.find(
      (country) =>
        country.dialCode === this.state.formData.user.mobile.countryCode
    );
    const pattern = country && country.regex ? country.regex : '';
    
    const regexObj = new RegExp(pattern);
    

    if (!regexObj.test(mobile)) {
      ismobileValid = false;
      return ismobileValid;
    } else {
      return true;
    }
    // else if (this.props.formErrors.number) {
    //   this.props.formErrors.number = 'This field is required.';
    //   return true;
    // }
    // if (mobile.length < 10 || mobile.length > 10) {
    //   ismobileValid = false;
    //   return ismobileValid;
    // } else if(this.props.formErrors.number){
    //   this.props.formErrors.number = 'This field is required.';
    //   return true;
    // }
  };

  handleRadio = (event: any, i: any) => {
    
    let name = event.target.name;
    let value = event.target.value;
    

    const newFormData = { ...this.state.formData };
    const newModuleAccess = [...newFormData.client.moduleAccess];
    newModuleAccess[i] = {
      ...newModuleAccess[i],
      isAllowed: value === 'Yes' ? true : false,
    };
    newFormData.client.moduleAccess = newModuleAccess;

    this.setState({
      formData: newFormData,
    });
  };
  checkForMasterClient(formData: any) {
    let data = formData;
    if(data && data.client.masterClient.id === ""){
     delete data.client.masterClient;
    }
    return data;
  }
  handleSubmit = (event: any) => {
    event.preventDefault();
    this.validateAllFields();
    let anyErrors = this.anyFormErrors();
    if (!anyErrors) {
      let payload = this.checkForMasterClient(this.state.formData)  
      // API call goes here via services
      console.log('payload', payload)
      let updatedPayload = {...payload}
      let updatedClient = {...payload.client}
      updatedClient.name = updatedClient.name.trim();
      updatedPayload.client = updatedClient;
      this.props.addClient(updatedPayload);
      
      }
  };

  validateAllFields = () => {
    let { formErrors } = this.state;

    const nameValidationResult = this.validateField(
      'name',
      this.state.formData.client.name.trim()
    );
    const addressValidationResult = this.validateField(
      'address',
      this.state.formData.client.address.trim()
    );
    const fullNameValidationResult = this.validateField(
      'fullName',
      this.state.formData.user.fullName.trim()
    );
    const emailValidationResult = this.validateField(
      'email',
      this.state.formData.user.email.trim()
    );
    const numberValidationResult = this.validateField(
      'number',
      this.state.formData.user.mobile.number.trim()
    );
    const empCodeValidationResult = this.validateField(
      'empCode',
      this.state.formData.user.empCode.trim()
    );

    if (nameValidationResult !== undefined && nameValidationResult !== '') {
      formErrors['name'] = nameValidationResult;
    }
    if (
      addressValidationResult !== undefined &&
      addressValidationResult !== ''
    ) {
      formErrors['address'] = addressValidationResult;
    }
    if (
      fullNameValidationResult !== undefined &&
      fullNameValidationResult !== ''
    ) {
      formErrors['fullName'] = fullNameValidationResult;
    }
    if (emailValidationResult !== undefined && emailValidationResult !== '') {
      formErrors['email'] = emailValidationResult;
    }
    if (numberValidationResult !== undefined && numberValidationResult !== '') {
      formErrors['number'] = numberValidationResult;
    }
    if (empCodeValidationResult !== undefined && empCodeValidationResult !== '') {
      formErrors['empCode'] = empCodeValidationResult;
    }

    if (
      formErrors.name !== 'valid' ||
      formErrors.address !== 'valid' ||
      formErrors.fullName !== 'valid' ||
      formErrors.number !== 'valid' ||
      formErrors.email !== 'valid' ||
      formErrors.empCode !== 'valid'
    ) {
      this.setState({
        isFormValid: false,
      });
    }

    this.setState({ formErrors });
  };

  anyFormErrors = () => {
    let errorsExist = false;

    if (
      this.state.formErrors.name !== 'valid' ||
      this.state.formErrors.address !== 'valid' ||
      this.state.formErrors.fullName !== 'valid' ||
      this.state.formErrors.number !== 'valid' ||
      this.state.formErrors.email !== 'valid' ||
      this.state.formErrors.empCode !== 'valid'
    ) {
      errorsExist = true;
      return errorsExist;
    }

    // Enable Submit Button Here
    this.setState({
      // ...this.state,
      isFormValid: true,
    });

    return errorsExist;
  };

  isFormEmptyCheck = () => {
    let isFormEmpty = true;
    if(
      this.state.formData.client.name.trim().length > 0 ||
      this.state.formData.client.address.trim().length > 0 ||
      this.state.formData.user.fullName.trim().length > 0 ||
      this.state.formData.user.email.trim().length > 0 ||
      this.state.formData.user.mobile.number.trim().length > 0 ||
      this.state.formData.user.empCode.trim().length > 0
    ) {
      isFormEmpty = false
    }
    return isFormEmpty;
  }

  handleReset = () => {
    this.setState({
      open: false,
      setOpen: false,
      formData: {
        client: {
          name: '',
          address: '',
          moduleAccess: [
            {
              type: 'module',
              name: 'goal',
              isAllowed: 'true',
            },
            {
              type: 'module',
              name: 'course',
              isAllowed: 'true',
            },
            {
              type: 'module',
              name: 'content',
              isAllowed: 'true',
            },
            {
              type: 'module',
              name: 'user',
              isAllowed: 'true',
            },
            {
              type: 'module',
              name: 'edp',
              isAllowed: 'true',
            },
          ],
          isBranchClient: false,
          masterClient: {
            id: '',
            name: ''
          }
        },
        user: {
          fullName: '',
          email: '',
          mobile: {
            countryCode: '+91',
            number: '',
          },
          empCode: '',
        },
      },
      formErrors: {
        name: 'valid',
        address: 'valid',
        fullName: 'valid',
        email: 'valid',
        number: 'valid',
        empCode: 'valid',
      },
      isFormValid: false,
    });
  };

  getCountryItemsList = () => {
    const countryList = getCountryList();
    const { classes } = this.props;

    const countryListMenuItems = countryList.map((country: any, index: any) => {
      return (
        <MenuItem
          key={index}
          value={`${country.dialCode}`}
          className={classes.menuItem}
        >
          <img src={`${country.flag}`} />
          {country.dialCode}
        </MenuItem>
      );
    });

    return countryListMenuItems;
  };

  handleCountryCodeChange = (event: any) => {
    const countryCode = event.target.value;
    const formData = this.state.formData;
    formData.user.mobile.countryCode = countryCode;
    this.setState({
      formData });
  };

  handleToaster = () => {
    
    this.props.addClientToastClose();
  };

  componentDidMount(){
    this.props.getMasterClients();
  }

  componentDidUpdate() {
    //check isadded and isAdding => redirect
    if(this.props.clientAddedSuccessfully && this.props.isIniitated) {
      if (
        this.props.formErrors.name === 'valid' &&
        this.props.formErrors.address === 'valid' &&
        this.props.formErrors.fullName === 'valid' &&
        this.props.formErrors.email === 'valid' &&
        this.props.formErrors.number === 'valid'&&
        this.props.formErrors.empCode === 'valid' &&
        this.state.formErrors.name === 'valid' &&
        this.state.formErrors.address === 'valid' &&
        this.state.formErrors.fullName === 'valid' &&
        this.state.formErrors.email === 'valid' &&
        this.state.formErrors.number === 'valid' &&
        this.state.formErrors.empCode === 'valid'
      ) {
        this.props.history.push('/userManagement');
      }
    }
  }

  componentWillUnmount() {
    this.props.isLoadingFalse();
  }

  renderSelectOptions = () => {
    let options = [];
    options.push(<option value={''}>{'Select Organization'}</option>)
    _.map(this.props.masterClientsData, (client: any, i: number) => (
      options.push(<option key={i} value={client._id} >{client.name}</option>)
    ))
    return options;
  }

  render() {
    const { classes, dialogCloseHandler } = this.props;
    const countryListItems = this.getCountryItemsList();
    
    return (
      <>
        {this.props.clientAddedSuccessfully && (
          <Grid
            className={[classes.customToaster, classes.successTooltip].join(
              ' '
            )}
          >
            <Typography variant="h6">
              <span>
                <CheckCircleIcon />
              </span>
              <span>Client Added Successfully</span>
              <span className="closeIcon" onClick={this.handleToaster}>
                <CloseIcon />
              </span>
            </Typography>
          </Grid>
        )
        
        
        
        }
        <Modal
          BackdropProps={{ invisible: true }}
          disablePortal
          disableEnforceFocus
          disableAutoFocus
          hideBackdrop={true} //@Neeraj: try to follow the Material UI doc for UI Arch
          className={[
            classes.fontSizeLG,
            classes.fontWeight500,
            classes.modal,
          ].join(' ')}
          open={true}
        >
          <div className={classes.paper}>
            <Card elevation={0}>
              <DialogHeader 
              urlName="/userManagement"
              selectedTab="Clients"
              iconNode={
                  <IconButton
                    aria-label="settings"
                    onClick={dialogCloseHandler}
                  >
                    <CloseIcon className={classes.fontSizeLG} />
                  </IconButton>              
              }
              headerTitle="Add New Client"
              />
             
              <CardContent className={classes.cardContentStyle}>
                {/* <form onSubmit={this.handleSubmit}> */}
                  <Card className={classes.CustomCard}>
                    <Grid container spacing={8}>
                      <Grid item xs={6}>
                        <Typography
                          variant="body1"
                          gutterBottom
                          className={classes.fontSizeMD}
                        >
                          Client/Org.
                        </Typography>
                        <MyPATTextField
                          className={classes.inputWidth}
                          fullWidthControl
                          inputId="name"
                          name="name"
                          placeholder="Enter the name of the client"
                          value={this.state.formData.client.name || ''}
                          onChange={this.handleChange.bind(this)}
                          error={
                            this.state.formErrors.name !== 'valid' ||
                            this.props.formErrors.name.includes(
                              'already exists'
                            )
                              ? true
                              : false
                          }
                          errorText={
                            this.state.formErrors.name === 'valid'
                              ? this.props.formErrors.name
                              : this.state.formErrors.name
                          }
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          variant="body1"
                          gutterBottom
                          className={classes.fontSizeMD}
                        >
                          Address
                        </Typography>
                        <MyPATTextField
                          className={[classes.inputWidth, classes.customTextarea].join(' ')}
                          fullWidthControl
                          inputId="address"
                          name="address"
                          placeholder="Enter Address"
                          multiline
                          rows={4}
                          // disabled={actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY}
                          value={this.state.formData.client.address || ''}
                          onChange={this.handleChange.bind(this)}
                          error={
                            this.state.formErrors.address !== 'valid' ||
                            this.props.formErrors.address.includes(
                              'Client address should'
                            )
                              ? true
                              : false
                          }
                          errorText={
                            this.state.formErrors.address === 'valid'
                              ? this.props.formErrors.address
                              : this.state.formErrors.address
                          }
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={8}>
                      <Grid item xs={6}>
                      <FormControlLabel
                          value="primary"
                          control={
                            <Checkbox
                          checked={this.state.formData.client.isBranchClient}
                          onClick={this.handleChange.bind(this)}
                          // classes={{
                          //   root: classes.checkbox,
                          //   checked: classes.checkedCheckbox,
                          //   colorPrimary: classes.primaryColor
                          // }}
                          color="primary"
                          name="checkbox"
                          // disabled={isInDisableContent(content._id, content.content_Id)} disableRipple
                           />
                          }
                          label="Client is a centre/branch*"
                          classes={{ label: classes.customLabel }}
                        />
                      
                            {/* <Typography
                          variant="body1"
                          gutterBottom
                          className={classes.fontSizeMD}
                        >
                          Client is a centre/branch
                        </Typography> */}
                      </Grid>
                      <Grid item xs={6}>
                      {  this.state.formData.client.isBranchClient && <><Typography
                          variant="body1"
                          gutterBottom
                          className={classes.fontSizeMD}
                        >
                          Main Organization
                        </Typography>
                       <MyPATSelect
                            // inputId={featurePermission}
                            // value={<option value={''} >{'Select Organization'}</option>}
                            name='masterClient'
                            onChange={(e: any) => this.handleChange(e)}
                            disabled={!this.state.formData.client.isBranchClient}
                            inputClass={classes.selectOrgStyle}
                          >
                            {
                              
                             this.renderSelectOptions()
                            }
                          </MyPATSelect></>}
                      </Grid>
                    </Grid>
                  </Card>

                  <Grid>
                    <Typography className={classes.CardTitle}>
                      Client/Org. Admin
                    </Typography>
                  </Grid>
                  <Card className={classes.CustomCard}>
                    <Grid container spacing={8} alignItems="center">
                      <Grid item xs={6}>
                        <Typography
                          variant="body1"
                          gutterBottom
                          className={classes.fontSizeMD}
                        >
                          Name
                        </Typography>
                        <MyPATTextField
                          className={classes.inputWidth}
                          fullWidthControl
                          inputId="fullName"
                          name="fullName"
                          placeholder="Enter the name of the admin"
                          value={this.state.formData.user.fullName}
                          onChange={this.handleChange.bind(this)}
                          error={
                            this.state.formErrors.fullName !== 'valid' ||
                            this.props.formErrors.fullName.includes(
                              'Client name should'
                            )
                              ? true
                              : false
                          }
                          errorText={
                            this.state.formErrors.fullName === 'valid'
                              ? this.props.formErrors.fullName
                              : this.state.formErrors.fullName
                          }
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          variant="body1"
                          gutterBottom
                          className={classes.fontSizeMD}
                        >
                          Email ID
                        </Typography>
                        <MyPATTextField
                          className={classes.inputWidth}
                          fullWidthControl
                          inputId="email"
                          name="email"
                          placeholder="Enter the email ID of the admin"
                          // disabled={actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY}
                          value={this.state.formData.user.email || ''}
                          onChange={this.handleChange.bind(this)}
                          error={
                            this.state.formErrors.email !== 'valid' ||
                            this.props.formErrors.email.includes('Email')
                              ? true
                              : false
                          }
                          errorText={
                            this.state.formErrors.email === 'valid'
                              ? this.props.formErrors.email
                              : this.state.formErrors.email
                          }
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={8} alignItems="center">
                      <Grid item xs={6}>
                        <Typography
                          variant="body1"
                          gutterBottom
                          className={classes.fontSizeMD}
                        >
                          Contact
                        </Typography>
                        <div className={classes.flagContainer}>
                          <FormControl>
                            <Select
                              value={
                                this.state.formData.user.mobile.countryCode
                              }
                              onChange={(e) => this.handleCountryCodeChange(e)}
                              displayEmpty
                              name="countryCode"
                              disableUnderline={true}
                              classes={{ root: classes.customSelect }}
                            >
                              {countryListItems}
                            </Select>
                          </FormControl>
                          <MyPATTextField
                            // className={classes.inputWidth}
                            fullWidthControl
                            className={[
                              classes.customInput,
                              classes.inputWidth,
                            ].join(' ')}
                            inputId="number"
                            name="number"
                            placeholder="Enter Contact No."
                            // disabled={actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY}
                            value={this.state.formData.user.mobile.number || ''}
                            onChange={this.handleChange.bind(this)}
                            endAdornment={<div></div>}
                            error={
                              this.state.formErrors.number !== 'valid' ||
                              this.props.formErrors.number.includes('Mobile')
                                ? true
                                : false
                            }
                            errorText={
                              this.state.formErrors.number === 'valid'
                                ? this.props.formErrors.number
                                : this.state.formErrors.number
                            }
                            type="number"
                          />
                        </div>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          variant="body1"
                          gutterBottom
                          className={classes.fontSizeMD}
                        >
                          EMP Code
                        </Typography>
                        <MyPATTextField
                          className={classes.inputWidth}
                          fullWidthControl
                          inputId="empCode"
                          name="empCode"
                          placeholder="Enter EMP Code"
                          type="number"
                          endAdornment={<div></div>}
                          // disabled={actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY}
                          value={this.state.formData.user.empCode || ''}
                          onChange={this.handleChange.bind(this)}
                          error={
                            this.state.formErrors.empCode !== 'valid' ||
                            this.props.formErrors.empCode.includes('EMP Code')
                              ? true
                              : false
                          }
                          errorText={
                            this.state.formErrors.empCode === 'valid'
                              ? this.props.formErrors.empCode
                              : this.state.formErrors.empCode
                          }
                        />
                      </Grid>
                    </Grid>
                  </Card>

                  <Grid>
                    <Typography className={classes.CardTitle}>
                      Module Access
                      <span className={classes.iconStyle}>
                        <CustomInfoIcon
                          isInfoIcon={true}
                          isCenterArrow={true}
                          isRightArrow={false}
                          knowMoreAbout={false}
                          dialogTitle="Modules Access"
                          imageURL="/assets/svg/lock-icon.svg"
                          dialogPara="Through this section, access for each module can be provided to the organization. All modules marked as 'Yes' will be available on the navigation panel
                           (left) of the client admin. The client admin will be able to give further access to other users of the Organization for the selected modules only "
                          toolTipDirection="top"
                          details="Click to know more"
                        />
                      </span>
                    </Typography>
                  </Grid>
                  <Card className={classes.CustomCard}>
                    <Grid container spacing={8} alignItems="center">
                      <Grid item xs={3}>
                        <Typography>Goal Management :</Typography>
                      </Grid>
                      <Grid item xs={9}>
                        <Grid container spacing={8} alignItems="center">
                          <FormGroup row>
                            <FormControlLabel
                              // classes={{ root: classes.labelText }}
                              // className={classes.marginTopMD}
                              className={classes.customRadio}
                              control={
                                <Radio
                                  color="primary"
                                  checked={Boolean(
                                    this.state.formData.client.moduleAccess[0]
                                      .isAllowed
                                  )}
                                  onChange={(event) =>
                                    this.handleRadio(event, 0)
                                  }
                                  value="Yes"
                                  name="goal"
                                />
                              }
                              label="Yes"
                            />

                            <FormControlLabel
                              // classes={{ root: classes.labelText }}
                              // className={classes.marginTopMD}
                              className={classes.customRadio}
                              control={
                                <Radio
                                  color="primary"
                                  checked={
                                    !Boolean(
                                      this.state.formData.client.moduleAccess[0]
                                        .isAllowed
                                    )
                                  }
                                  onChange={(event) =>
                                    this.handleRadio(event, 0)
                                  }
                                  value="No"
                                  name="goal"
                                />
                              }
                              label="No"
                            />
                          </FormGroup>
                          <FormGroup row>
                            <Grid
                              justify="center"
                              className={classes.flexContainer}
                            >
                              <Typography className={classes.customRadio}>
                                User Management :
                              </Typography>
                              <FormControlLabel
                                // classes={{ root: classes.labelText }}
                                // className={classes.marginTopMD}
                                className={classes.customRadio}
                                control={
                                  <Radio
                                    color="primary"
                                    checked={Boolean(
                                      this.state.formData.client.moduleAccess[3]
                                        .isAllowed
                                    )}
                                    onChange={(event) =>
                                      this.handleRadio(event, 3)
                                    }
                                    value="Yes"
                                    name="user"
                                  />
                                }
                                label="Yes"
                              />

                              <FormControlLabel
                                // classes={{ root: classes.labelText }}
                                // className={classes.marginTopMD}
                                className={classes.customRadio}
                                control={
                                  <Radio
                                    color="primary"
                                    checked={
                                      !Boolean(
                                        this.state.formData.client
                                          .moduleAccess[3].isAllowed
                                      )
                                    }
                                    onChange={(event) =>
                                      this.handleRadio(event, 3)
                                    }
                                    value="No"
                                    name="user"
                                  />
                                }
                                label="No"
                              />
                            </Grid>
                          </FormGroup>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid container spacing={8} alignItems="center">
                      <Grid item xs={3}>
                        <Typography>Course Management :</Typography>
                      </Grid>
                      <Grid item xs={9}>
                        <Grid container spacing={8} alignItems="center">
                          <FormGroup row>
                            <FormControlLabel
                              // classes={{ root: classes.labelText }}
                              // className={classes.marginTopMD}
                              className={classes.customRadio}
                              control={
                                <Radio
                                  color="primary"
                                  checked={Boolean(
                                    this.state.formData.client.moduleAccess[1]
                                      .isAllowed
                                  )}
                                  onChange={(event) =>
                                    this.handleRadio(event, 1)
                                  }
                                  value="Yes"
                                  name="course"
                                />
                              }
                              label="Yes"
                            />

                            <FormControlLabel
                              // classes={{ root: classes.labelText }}
                              // className={classes.marginTopMD}
                              className={classes.customRadio}
                              control={
                                <Radio
                                  color="primary"
                                  checked={
                                    !Boolean(
                                      this.state.formData.client.moduleAccess[1]
                                        .isAllowed
                                    )
                                  }
                                  onChange={(event) =>
                                    this.handleRadio(event, 1)
                                  }
                                  value="No"
                                  name="course"
                                />
                              }
                              label="No"
                            />
                          </FormGroup>
                          <FormGroup row>
                            <Grid
                              justify="center"
                              className={classes.flexContainer}
                            >
                              <Typography
                                className={[
                                  classes.customRadio,
                                  classes.labelCustomWidth,
                                ].join(' ')}
                              >
                                EDP Reports :
                              </Typography>
                              <FormControlLabel
                                // classes={{ root: classes.labelText }}
                                // className={classes.marginTopMD}
                                className={classes.customRadio}
                                control={
                                  <Radio
                                    color="primary"
                                    checked={Boolean(
                                      this.state.formData.client.moduleAccess[4]
                                        .isAllowed
                                    )}
                                    onChange={(event) =>
                                      this.handleRadio(event, 4)
                                    }
                                    value="Yes"
                                    name="EDPReports"
                                  />
                                }
                                label="Yes"
                              />

                              <FormControlLabel
                                // classes={{ root: classes.labelText }}
                                // className={classes.marginTopMD}
                                className={classes.customRadio}
                                control={
                                  <Radio
                                    color="primary"
                                    checked={
                                      !Boolean(
                                        this.state.formData.client
                                          .moduleAccess[4].isAllowed
                                      )
                                    }
                                    onChange={(event) =>
                                      this.handleRadio(event, 4)
                                    }
                                    value="No"
                                    name="EDPReports"
                                  />
                                }
                                label="No"
                              />
                            </Grid>
                          </FormGroup>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid container spacing={8} alignItems="center">
                      <Grid item xs={3}>
                        <Typography>Content Request :</Typography>
                      </Grid>
                      <Grid item xs={9}>
                        <Grid container spacing={8} alignItems="center">
                          <FormGroup row>
                            <FormControlLabel
                              // classes={{ root: classes.labelText }}
                              // className={classes.marginTopMD}
                              className={classes.customRadio}
                              control={
                                <Radio
                                  color="primary"
                                  checked={Boolean(
                                    this.state.formData.client.moduleAccess[2]
                                      .isAllowed
                                  )}
                                  onChange={(event) =>
                                    this.handleRadio(event, 2)
                                  }
                                  value="Yes"
                                  name="contentRequest"
                                />
                              }
                              label="Yes"
                            />

                            <FormControlLabel
                              // classes={{ root: classes.labelText }}
                              // className={classes.marginTopMD}
                              className={classes.customRadio}
                              control={
                                <Radio
                                  color="primary"
                                  checked={
                                    !Boolean(
                                      this.state.formData.client.moduleAccess[2]
                                        .isAllowed
                                    )
                                  }
                                  onChange={(event) =>
                                    this.handleRadio(event, 2)
                                  }
                                  value="No"
                                  name="contentRequest"
                                />
                              }
                              label="No"
                            />
                          </FormGroup>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Card>
                {/* </form> */}
              </CardContent>
              
              <DialogFooter 
              htmlElements = {
                <>
                <Button
                    variant="contained"
                    color="primary"
                    className={classes.resetButton}
                    type="submit"
                    // disabled={!this.state.isFormValid}
                    onClick={this.handleReset}
                  >
                    Reset
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.btnCreateGoal}
                    type="submit"
                    // disabled={!this.state.isFormValid}
                    onClick={this.handleSubmit}
                  >
                    Add Client
                  </Button>
                </>
              }
              />
              
            </Card>
          </div>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state: any) => ({
  formErrors: state.clientManagement.clientMgmt.formErrors,
  clientAddedSuccessfully:
    state.clientManagement.clientMgmt.clientAddedSuccessfully,
  isIniitated: state.clientManagement.clientMgmt.isIniitated,
  masterClientsData:
  state.clientManagement.clientMgmt.masterClientsData 
  &&
  state.clientManagement.clientMgmt.masterClientsData.clients
});

const mapDispatchToProps = {
  addClient,
  addClientToastClose,
  addClientCorrection,
  isLoadingTrue,
  isLoadingFalse,
  getMasterClients
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(userStyles)(withRouter(AddClientDialog)));
